/* @flow */

import React from 'react';
import styled from 'styled-components';
import {
  Select,
  Modal,
  Button,
  Input,
  Message,
  // $FlowFixMe
} from '@bijie/react-bnb';
import FlexBox from '../FlexBox';
import { ImageBox } from '../EmptyTable';
import { getLabel } from '../../utils/i18n';
import {
  bigNumberEqual,
  formatBigNumber,
  bigNumberGreaterThan,
  bigNumberLessThanOrEqual,
  bigNumberGreaterThanOrEqual,
} from '../../utils/number';
import { amountValidate } from '../../utils/validate';
import {
  marginTransferIn,
  marginTransferOut,
  fetchMaxTransferOutAmout,
} from '../../actions/actionsSet/margin';

export const NUMBER_ONLY_REGREX = /^\d+\.?\d*$/;
const NUMBER_STARTS_ZEOR_REGX = /^0\d+/;

export const StyledModal = styled(Modal)`
  display: inline-block;
  width: 500px !important;
  font-size: 14px;
  color: #48515D;
  .bnc-modal-header {
    position: relative;
    color: #000;
    text-align: center;
    padding: 19px 0 21px 0;
    border-bottom: 2px solid ${({ noPadding }) => noPadding ? '#EAECEF' : '#F0B90B'};
  }
  .bnc-modal-title {
    font-size: 16px;
    line-height: 20px;
  }
  .bnc-modal-content {
    border-radius: 5px;
  }
  .bnc-modal-body {
    ${({ noPadding }) => noPadding && 'padding: 40px 0;'}
  }
  .bnc-input-clear-icon {
    display: none !important;
  }
  .bnc-modal-close {
    z-index: 1;
  }
  .bnc-input {
    font-size: 20px;
    font-weight: 500;
  }
`;

export const Line = styled.div`
  position: relative;
  padding-top: ${({ padding = 30 }) => `${padding}px`};
`;
const LineInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  .switch {
    width: 25px;
    height: 18px;
  }
`;

export const Label = styled.label`
  font-size: 14px;
  line-height: 18px;
  color: #a3a3a3;
`;
export const TipBox = styled.div`
  position: absolute;
  bottom: 6px;
  right: 0;
  color: #f0b90b;
  cursor: pointer;
`;
const CursorPointer = styled.span`
  cursor: pointer;
  span::before {
    border: 2px solid #f0b90b;
  }
`;
export const StyledSelect = styled(Select)`
  .bnc-select-dropdown-menu {
    max-height: 322px;
  }
  .bnc-select-selection--single {
    box-sizing: content-box;
    padding: 12px 0 10px 0;
    height: 26px;
    margin-top: -5px;
    line-height: 26px;
  }
`;
const StyledOption = styled(FlexBox)`
  line-height: 26px;
  height: 26px;
`;
const Coin = styled.span`
  line-height: 15px;
  font-size: 16px;
  padding-right: 10px;
  font-weight: bold;
`;
const FooterBox = styled.div`
  ${({ isTransfer = false }) => isTransfer ? 'padding-top: 40px;' : 'position: absolute;left: 0;bottom:0;width:100%;'}
  > .bnc-btn {
    width: 100%;
  }
`;
const Spin = styled(FlexBox)`
  position: relative;
  width: 180px;
  height: 40px;
  border-radius: 20px;
  text-align: center;
  color: #848E9C;
  background: rgba(234,236,239,.5);
  i {
    vertical-align: middle;
    margin-right: 5px;
  }
  .wallet {
    width: 20px;
    margin-right: 5px;
  }
`;
const SpinLabel = styled.label`
  position: absolute;
  left: 50%;
  top: -60%;
  transform: translateX(-50%);
  line-height: 18px;
`;
export const ErrorMsg = styled.p`
  position: absolute;
  left: 0;
  top: 100%;
  margin: 5px 0 0;
  color: #F23051;
  font-size: 12px;
  line-height: 15px;
`;
const ErrorTipBox = styled.div`
  display: flex;
  align-items: center;
  margin-top: 7px;
  padding: 14px 20px;
  border-radius: 4px;
  line-height: 20px;
  color: #F23051;
  background: rgba(242,48,81,.06);
  .prompt {
    margin-right: 10px;
    width: 20px;
  }
`;

export const ErrorLine = ({
  msg,
  asset,
}: Object) => (
  <Line>
    <ErrorTipBox>
      <img className="prompt" src={require('../../static/images/margin/prompt-hollow.svg')} alt="icon" />
      {msg.replace('%asset%', asset)}
    </ErrorTipBox>
  </Line>
);
const TransferTip = styled.div`
  margin: 25px 0 0 0;
`;

export const CoinOption = ({ asset, assetName, logoUrl }: Object) => (
  <StyledOption align="center">
    <ImageBox size="26">
      <img src={logoUrl} alt="" />
    </ImageBox>
    <Coin>{asset}</Coin>
    <Label>{assetName}</Label>
  </StyledOption>
);
export const FooterComp = ({
  onOk, onOkText, disable, isLoading, loadingText, isTransfer,
}: Object) => (
  <FooterBox isTransfer={isTransfer}>
    {
      isLoading
        ? (
          <Button disabled={true} size="lg">
            <ImageBox size="26" needCircle={false}>
              <img src="../../../static/images/blog/loading.gif" alt="x" />
            </ImageBox>
            {loadingText}
          </Button>
        )
        : <Button type="primary" size="lg" disabled={disable} onClick={() => onOk()}>{onOkText}</Button>
    }
  </FooterBox>
);


export const RGEX = /[^0-9.]/g;
const allWidth = { width: '100%' };
export const filedRules = [
  {
    validate: (value: string) => value,
    errorKey: 'required',
  },
  {
    validate: (value: string) => !NUMBER_STARTS_ZEOR_REGX.test(value) && bigNumberGreaterThan(value, '0'),
    errorKey: 'invalid',
  },
  {
    validate: (value: string, type: string, balance: string) => type === 'borrow' || bigNumberLessThanOrEqual(value, balance),
    errorKey: 'ltbalance',
  },
  {
    validate: (value: string, type: string, balance: string) => type !== 'borrow' || bigNumberLessThanOrEqual(value, balance),
    errorKey: 'ltBorrowLimit',
  },
  {
    validate: (value: string) => {
      let result = true;
      const arr = value.split('.');
      arr.length > 1 && arr[1].length > 8 && (result = false);
      return result;
    },
    errorKey: 'lt8Decimal',
  },
  {
    validate: (value: string, type: string, balance: string, minDebt: string) => type !== 'borrow' || bigNumberGreaterThanOrEqual(value, minDebt),
    errorKey: 'stDebit',
    formatter: (errorMsg: string, ...rest: Array<any>) => errorMsg.replace(/\$minDebit/, rest[2]),
  },
  {
    validate: (value: string, type: string, balance: string, maxDebt: string) => type !== 'repay' || bigNumberLessThanOrEqual(value, maxDebt),
    errorKey: 'ltTotalDebit',
  },
  {
    validate: (value: string, type: string, balance: string, maxDebt: string, maxRepay: string) => (
      type !== 'repay' || bigNumberEqual(value, maxDebt) || bigNumberLessThanOrEqual(value, maxRepay)
    ),
    errorKey: 'stMaxRepay',
    formatter: (errorMsg: string, ...rest: Array<any>) => errorMsg.replace(/\$maxRepay/, rest[3]),
  },
  {
    validate: (value: string, type: string, balance: string, maxDebt: string, maxRepay: string, minRepay: string) => (
      type !== 'repay' || bigNumberGreaterThanOrEqual(value, minRepay)
    ),
    errorKey: 'stMinRepay',
    formatter: (errorMsg: string, ...rest: Array<any>) => errorMsg.replace(/\$minRepay/, rest[4]),
  },
];

type Props = {
  i18n: Object,
  userAssets: Array<Object>,
  callback: Function
}
type States = {
  visible: bool,
  isTrans: bool,
  amount: string,
  errorMsg: string,
  curAsset: Object,
  isFetching: bool,
  curMaxMount: string,
}

export default class TransferModal extends React.PureComponent<Props, States> {
  static defaultProps={
    userAssets: [],
  }

  state = {
    visible: false,
    isTrans: false,
    amount: '0',
    errorMsg: '',
    curAsset: { asset: {}, isMortgageable: false, netAsset: '' },
    isFetching: false,
    curMaxMount: '0',
  }

  showModal = (asset: Object) => {
    this.setState({
      curAsset: asset,
      visible: true,
      amount: '0',
      errorMsg: '',
    }, async () => {
      const curMaxMount = await this.getMaxAmount(asset);
      this.setState({
        curMaxMount,
      });
    });
  }

  getMaxAmount = async ({
    asset, maxTransferAmount, isMortgageable, netAsset,
  }: Object) => {
    const { isTrans } = this.state;
    let amount = '0';
    if (isTrans) {
      amount = await fetchMaxTransferOutAmout(asset);
    } else if (!isMortgageable && +netAsset < 0) {
      amount = `${-netAsset}`;
    } else {
      amount = formatBigNumber(maxTransferAmount, 8);
    }
    return amount;
  }

  setMaxAmout = async () => {
    const { curAsset } = this.state;
    const curMaxMount = await this.getMaxAmount(curAsset);
    this.setState({
      curMaxMount,
    });
  }

  _transfer = async () => {
    const { i18n } = this.props;
    const { amount, isTrans, curAsset: { asset, isMortgageable, netAsset } } = this.state;
    const isDisable = !isTrans && !isMortgageable && +netAsset >= 0;
    if (isDisable) return;
    const validate = this._validate();
    if (!validate) return;
    this.setState({
      isFetching: true,
    });
    const params = {
      asset,
      amount,
    };
    let reload = false;
    try {
      isTrans ? await marginTransferOut(params) : await marginTransferIn(params);
      Message.success(getLabel('exchange-TransferModal-TransferCompleted', i18n));
      reload = true;
    } catch (error) {
      const message = error.message.split(',').reduce((cur, next) => cur + getLabel(next, i18n), '');
      Message.fail(message);
    } finally {
      this.setState({
        isFetching: false,
      });
      this._closeModal(reload);
    }
  }

  _toggleTrans = () => {
    this.setState({
      isTrans: !this.state.isTrans,
    }, this.setMaxAmout);
  }

  _handleInputChange = (value: string) => {
    if (!NUMBER_ONLY_REGREX.test(value) && value.length !== 0) {
      return undefined;
    }
    return this.setState({
      amount: value,
    });
  }

  _handleSelectChange = async (asset: string) => {
    const assetObj = this.props.userAssets.find(symbol => symbol.asset === asset);
    if (assetObj) {
      const curMaxMount = await this.getMaxAmount(assetObj);
      this.setState({
        amount: '0',
        curAsset: assetObj,
        curMaxMount,
        errorMsg: '',
      });
    }
  }

  _hanldeTipClick = () => {
    const { curMaxMount } = this.state;
    this.setState({
      amount: curMaxMount,
    });
  }

  _closeModal = (reload: bool = false) => {
    this.setState({
      visible: false,
    });
    this.props.callback(reload);
  }

  _validate = () => {
    const { i18n } = this.props;
    const { amount, curMaxMount } = this.state;
    const { validate, errorMsg } = amountValidate(amount, filedRules, i18n, 'transfer', curMaxMount);
    this.setState({
      errorMsg,
    });
    return validate;
  }

  render() {
    const { i18n, userAssets } = this.props;
    const {
      isTrans,
      visible,
      amount,
      errorMsg,
      curAsset,
      isFetching,
      curMaxMount,
    } = this.state;
    const isDisable = !isTrans && !curAsset.isMortgageable;
    const curAssetName = curAsset.asset;
    const netAsset = +curAsset.netAsset;
    return (
      <StyledModal
        footer={null}
        centered={true}
        visible={visible}
        title={getLabel('exchange-TransferModal-Transfer', i18n)}
        onCancel={() => this._closeModal()}
      >
        <Line padding="0">
          <LineInner>
            <Spin justify="center" align="center">
              <SpinLabel>{getLabel('exchange-TransferModal-From', i18n)}</SpinLabel>
              {
                isTrans
                  ? (
                    <React.Fragment>
                      <img className="wallet" src={require('../../static/images/margin/margin-wallet.svg')} alt="icon" />
                      {getLabel('exchange-TransferModal-MarginAccount', i18n)}
                    </React.Fragment>
                  )
                  : (
                    <React.Fragment>
                      <img className="wallet" src={require('../../static/images/margin/exchange-wallet.svg')} alt="icon" />
                      {getLabel('exchange-TransferModal-ExchangeAccount', i18n)}
                    </React.Fragment>
                  )
              }
            </Spin>
            <CursorPointer>
              <ImageBox onClick={this._toggleTrans} size="34" right="0">
                <img src={require('../../static/images/margin/switch.svg')} className="switch" alt="icon" />
              </ImageBox>
            </CursorPointer>
            <Spin justify="center" align="center">
              <SpinLabel>{getLabel('exchange-TransferModal-To', i18n)}</SpinLabel>
              {
                isTrans
                  ? (
                    <React.Fragment>
                      <img className="wallet" src={require('../../static/images/margin/exchange-wallet.svg')} alt="icon" />
                      {getLabel('exchange-TransferModal-ExchangeAccount', i18n)}
                    </React.Fragment>
                  )
                  : (
                    <React.Fragment>
                      <img className="wallet" src={require('../../static/images/margin/margin-wallet.svg')} alt="icon" />
                      {getLabel('exchange-TransferModal-MarginAccount', i18n)}
                    </React.Fragment>
                  )
              }
            </Spin>
          </LineInner>
        </Line>
        <Line>
          <Label>{getLabel('exchange-common-coin', i18n)}</Label>
          <StyledSelect
            value={<CoinOption {...curAsset} />}
            defaultActiveFirstOption={false}
            showSearch={false}
            style={allWidth}
            onChange={this._handleSelectChange}
          >
            {
              userAssets.map(({
                asset, assetName, logoUrl,
              }) => (
                <Select.Option value={asset} key={asset}>
                  <CoinOption asset={asset} assetName={assetName} logoUrl={logoUrl} />
                </Select.Option>
              ))
            }
          </StyledSelect>
        </Line>
        {
          isDisable && netAsset >= 0
            ? (
              <ErrorLine
                asset={curAsset.asset}
                msg={getLabel('exchange-TransferModal-transferMargin', i18n)}
              />
            )
            : (
              <Line>
                <Label>{getLabel('exchange-common-amount', i18n)}</Label>
                <Input
                  value={amount}
                  style={allWidth}
                  onBlur={this._validate}
                  onChange={this._handleInputChange}
                />
                <ErrorMsg>
                  {errorMsg}
                </ErrorMsg>
                <TipBox onClick={this._hanldeTipClick}>
                  <Label>{getLabel('exchange-TransferModal-avaliable', i18n)}:</Label>&nbsp;{curMaxMount}&nbsp;&nbsp;{curAsset.asset}
                </TipBox>
              </Line>
            )
          }
        {
          isDisable && netAsset < 0
            ? (
              <TransferTip>
                {
                  getLabel('exchange-TransferModal-trasferLimitTip', i18n).replace(/%asset%/g, String(curAssetName)).replace('%num%', String(-netAsset))
                }
              </TransferTip>
            )
            : null
        }
        <FooterComp
          isTransfer={true}
          onOk={this._transfer}
          onOkText={getLabel('exchange-TransferModal-confirmTransfer', i18n)}
          disable={isDisable && netAsset >= 0}
          isLoading={isFetching}
          loadingText={getLabel('exchange-common-processing', i18n)}
        />
      </StyledModal>
    );
  }
}
